var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 0H1.5C0.67157 0 0 0.671631 0 1.5V5.25C0 5.52612 0.223862 5.75 0.5 5.75H5.384C5.42892 5.74878 5.47246 5.73413 5.509 5.70801C9.44296 3.09741 14.558 3.09741 18.492 5.70801C18.5282 5.73413 18.5714 5.74878 18.616 5.75H23.5C23.7761 5.75 24 5.52612 24 5.25V1.5C24 0.671631 23.3284 0 22.5 0ZM17.75 3.75C17.3358 3.75 17 3.41418 17 3C17 2.58582 17.3358 2.25 17.75 2.25C18.1642 2.25 18.5 2.58582 18.5 3C18.5 3.19885 18.421 3.38965 18.2803 3.53027C18.1397 3.67102 17.9489 3.75 17.75 3.75ZM20.75 2.25C20.3358 2.25 20 2.58582 20 3C20 3.41418 20.3358 3.75 20.75 3.75C20.9489 3.75 21.1397 3.67102 21.2803 3.53027C21.421 3.38965 21.5 3.19885 21.5 3C21.5 2.58582 21.1642 2.25 20.75 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.616 7.25H23.5C23.7761 7.25 24 7.47388 24 7.75V22.5C24 23.3285 23.3284 24 22.5 24H1.5C0.67157 24 0 23.3285 0 22.5V7.75C0 7.47388 0.223862 7.25 0.5 7.25H5.384C5.72552 7.2489 6.05901 7.14624 6.342 6.95508C9.78474 4.72498 14.2163 4.72498 17.659 6.95508C17.9416 7.14636 18.2748 7.24902 18.616 7.25ZM5.5 14.5C5.5 18.0898 8.41016 21 12 21C15.5898 21 18.5 18.0898 18.5 14.5C18.5 10.9102 15.5898 8 12 8C8.41016 8 5.5 10.9102 5.5 14.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.5C7.5 12.0148 9.51472 10 12 10C14.4841 10.0028 16.4972 12.0159 16.5 14.5C16.5 16.9852 14.4853 19 12 19C9.51472 19 7.5 16.9852 7.5 14.5ZM9.5 14.5C9.5 15.8807 10.6193 17 12 17C13.3807 17 14.5 15.8807 14.5 14.5C14.5 13.1193 13.3807 12 12 12C10.6193 12 9.5 13.1193 9.5 14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.765e48d8.svg";
export { ForwardRef as ReactComponent };